import { render } from "./ItemReceive_info.vue?vue&type=template&id=597b8b66"
import script from "./ItemReceive_info.vue?vue&type=script&lang=js"
export * from "./ItemReceive_info.vue?vue&type=script&lang=js"

import "./ItemReceive_info.vue?vue&type=style&index=0&id=597b8b66&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__